import React from "react";
import {HeroInfoPage} from "../common/HeroInfoPage";

export const StayYouthful = (props) => {
    return (
        <HeroInfoPage
            {...props}
            imageSrc="/static/image/questionnaire/fasting/skin-benefits/stay-youthful-hero.png"
            title="Stay youthful with intermittent fasting"
            pageClassName="stay-youthful-page"
        >
            <p className="hero-info-description">
                Research shows intermittent fasting can <span className="hero-info-highlight">slow signs of aging</span>.
            </p>
            <p className="hero-info-description">
                It supports your <span className="hero-info-highlight">skin, heart, and overall vitality</span> - helping you look and feel your best.
            </p>
        </HeroInfoPage>
    );
};
